module.exports = __webpack_public_path__ + "resources/img/img-secuve-tos-01-en.df0708aa4a579375e8a9482c5a3ac177.png";